import { useMutation } from '@tanstack/react-query';
import { message } from 'antd';

import { apiMutation } from 'app/utils/request/api';

import { ENDPOINTS } from '.';

export function useResendUserMail(code: string) {
  return useMutation({
    mutationFn: async () =>
      apiMutation('POST', {
        path: ENDPOINTS.resendUserMail,
        params: { bookingCode: code },
      }) as Promise<void>,
    onSuccess: () => {
      message.success('User mail successfully resent');
    },
    onError: () => {
      message.error('Failed to resend user mail');
    },
  });
}
